import type { MaskedInputProps as PlatformMaskedInputProps } from '@platform-ui/input';
import { MaskedInputGlobal as PlatformMaskedInput } from '@platform-ui/input';
import Loader from '@platform-ui/loader';

export type Props = PlatformMaskedInputProps & {
  confirmed?: boolean;
  checking?: boolean;
};

export const InputOtp = (props: Props) => {
  const {
    mask = 'XXXXXX',
    maskTransitions = { X: /\d/ },
    placeholder = '••••••',
    label = 'Code',
    confirmed,
    checking,
    value,
    ...inputProps
  } = props;

  const getRightContent = () => {
    if (confirmed) {
      return <span>+</span>;
    }
    if (checking) {
      return <Loader size="s" color="var(--tds-color-primary)" />;
    }
    return null;
  };

  return (
    <PlatformMaskedInput
      inputMode="numeric"
      mask={mask}
      maskedValue={value}
      label={label}
      disabled={checking}
      maskTransitions={maskTransitions}
      placeholder={placeholder}
      rightContent={getRightContent()}
      {...inputProps}
    />
  );
};
